import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="nf-container">
      <div className="nf-content">
        <div className="nf-error-code">
          <span className="nf-digit nf-digit-four">4</span>
          <span className="nf-digit nf-digit-zero">0</span>
          <span className="nf-digit nf-digit-four">4</span>
        </div>
        
        <h1 className="nf-error-title">Pagina niet gevonden</h1>
        <p className="nf-error-description">
          Sorry, de pagina die je zoekt bestaat niet of is verplaatst.
        </p>
        
        <div className="nf-button-container">
          <button 
            className="nf-btn nf-btn-primary"
            onClick={() => navigate('/')}
          >
            Naar startpagina
          </button>
          <button 
            className="nf-btn nf-btn-secondary"
            onClick={() => navigate(-1)}
          >
            Terug
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;